import React, { Component, Fragment } from "react";

// fonction appelée par Deducer, qui envoie des props sur un exercice de logique (qui ont pour origine le fichier Exercices.json) ainsi que valueInference
class ShowInfoSandbox extends Component {
  updateState(object) {
    this.setState({});
  }

  renderRequirement(type) {
    let checkClassName = "unchecked";
    const conditions = {
      "Prémisse·s écrite·s": this.props.sandboxDataSent.premisses.length > 0,
      "Conclusion écrite": this.props.sandboxDataSent.conclusion.length > 1,
      "Conclusion atteinte": this.props.sandboxDataSent.conclusionReached,
      "Règle·s choisie·s": this.props.sandboxDataSent.rulesImplied.length > 0,
      "Signification·s possible·s":
        this.props.sandboxDataSent.possibleMeaning.length > 0,
    };
    checkClassName = conditions[type] ? "checked" : "unchecked";

    return (
      <li className="user-box-singleCondition selectable">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {type}
          {this.props.sandboxDataSent.conclusion}
          <i className={"fas fa-check " + checkClassName} />
        </div>
      </li>
    );
  }

  render() {
    return (
      <Fragment>
        Données à compléter avant de pouvoir valider la création de cet exercice
        :
        <ul className="user-box-allCondition">
          {this.renderRequirement("Prémisse·s écrite·s")}
          {this.renderRequirement("Conclusion écrite")}
          {this.renderRequirement("Conclusion atteinte")}
          {this.renderRequirement("Règle·s choisie·s")}
          {this.renderRequirement("Signification·s possible·s")}
        </ul>
      </Fragment>
    );
  }
}
export default ShowInfoSandbox;



// WEBPACK FOOTER //
// ./src/components/Pages/Components/SandboxShowUserRequirements.js